module.exports = __webpack_public_path__ + "static/media/PowerShape.166b1321.png";